import { render, staticRenderFns } from "./customTag.vue?vue&type=template&id=f90f9ef2&scoped=true&"
import script from "./customTag.vue?vue&type=script&lang=js&"
export * from "./customTag.vue?vue&type=script&lang=js&"
import style0 from "./customTag.vue?vue&type=style&index=0&id=f90f9ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90f9ef2",
  null
  
)

export default component.exports